import React, { memo, useCallback, useState, useEffect } from 'react';
import { PlacesAutocomplete } from '@yme/atoms/autocomplete-places';
import { useDispatch } from '@yme/hooks/useDispatch';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS } from '@yme/modals/constants';
import { useTranslation } from '@yme/services/i18n';
import { DealerItems } from './DealerItems';
import { HeaderContainerStyled, HeaderTitleStyled, ContainerStyled, HeaderSubtitleStyled, InputContainerStyled, } from './styled';
export const PreferredDealer = memo(({ googleApiKey, isRequired, dealers, selectedDealerId, country, isLocationClear, isRightToLeft, showHeader = true, inputTitleLabel, inputPlaceholderLabel, hasError = false, errorMessage = '', isGBCountyRoot, additionalCountries = [], onLocationSelect, onMyLocationPress, onDealerSelect, onBlur, onApplySelection, isControlPanelHidden = false, isClearPreferredDealer = false, isShowChooseFromMap = false, }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [showDealersList, setShowDealersList] = useState(!!(selectedDealerId || isControlPanelHidden));
    const [myGeolocation, setMyGeolocation] = useState(null);
    const [inputLocation, _setInputLocation] = useState(null);
    const setInputLocation = useCallback((location) => {
        setShowDealersList(true);
        _setInputLocation(location);
        onLocationSelect(location);
    }, [onLocationSelect]);
    useEffect(() => {
        if (selectedDealerId && !showDealersList) {
            setShowDealersList(true);
        }
    }, [selectedDealerId, showDealersList]);
    useEffect(() => {
        if (isLocationClear) {
            _setInputLocation(null);
        }
    }, [isLocationClear]);
    useEffect(() => {
        if (isClearPreferredDealer) {
            setShowDealersList(false);
            _setInputLocation(null);
        }
    }, [isClearPreferredDealer]);
    const handleMyGeolocationObtain = useCallback(({ coordinates }) => {
        setMyGeolocation(coordinates);
    }, []);
    const showMap = useCallback(() => {
        dispatch(setIsModalShowed({
            type: MODALS.MAP_MODAL_NEW,
            data: {
                googleApiKey,
                dealers,
                myGeolocation,
                inputLocation,
                selectedDealerId,
                onDealerSubmit: onDealerSelect,
                setInputLocation,
                isHiddenCloseIcon: true,
            },
        }));
    }, [
        dealers,
        dispatch,
        googleApiKey,
        inputLocation,
        myGeolocation,
        selectedDealerId,
        onDealerSelect,
        setInputLocation,
    ]);
    return (React.createElement(ContainerStyled, null,
        showHeader && (React.createElement(HeaderContainerStyled, null,
            React.createElement(HeaderTitleStyled, null, t('common_preferredDealer_header')),
            React.createElement(HeaderSubtitleStyled, null, t('common_preferredDealer_description')))),
        !isControlPanelHidden && (React.createElement(InputContainerStyled, null,
            React.createElement(PlacesAutocomplete, { apiKey: googleApiKey, value: inputLocation?.label, countries: [country], additionalCountries: additionalCountries, title: inputTitleLabel || t('common_preferredDealerLocationInput_label'), placeholder: inputPlaceholderLabel || t('common_preferredDealerLocationInput_placeholder'), isRightToLeft: isRightToLeft, isRequired: isRequired, hasError: hasError, errorMessage: errorMessage, 
                // todo: md: use predefined handler instead of setInputLocation
                onClear: setInputLocation, onOptionSelect: setInputLocation, onMyGeolocationPress: onMyLocationPress, onMyGeolocationObtain: handleMyGeolocationObtain, onBlur: onBlur }))),
        React.createElement(DealerItems, { isGBCountyRoot: isGBCountyRoot, googleApiKey: googleApiKey, isRightToLeft: isRightToLeft, dealers: dealers, showDealersList: showDealersList, selectedDealerId: selectedDealerId, setInputLocation: setInputLocation, onDealerSelect: onDealerSelect, onApplySelection: onApplySelection, onMapButtonClick: showMap, isControlPanelHidden: isControlPanelHidden, isShowChooseFromMap: isShowChooseFromMap })));
});
PreferredDealer.displayName = 'PreferredDealer';
